import React from 'react'
import { Image, Platform, Touchable, TouchableOpacity, View, ViewStyle } from 'react-native'
import { spacing, color } from '../../theme'
import { HeaderProps } from './header.props'
import { Button } from '../button'
import { Avatar } from '../avatar'
import { Text } from '../text'
import { SvgIcon } from '../svg-icon'

// Styling
const ROOT: ViewStyle = {
  width: '100%',
  flexDirection: 'row',
  paddingHorizontal: Platform.OS === 'web' ? 0 : 20,
  alignItems: 'center',
  backgroundColor: color.white,
  // height: 36,
  paddingBottom: 12,
  paddingTop: 6,
}
const TITLE: ViewStyle = {
  flex: 1,
  flexDirection: 'row',
}
const SPACER: ViewStyle = { width: 24 }

/**
 * Header that appears on many screens. Will hold navigation buttons and screen title.
 */
export const Header: React.FunctionComponent<HeaderProps> = (props) => {
  const {
    center,
    onRightPress,
    onLeftPress,
    headerText,
    headerTx,
    rightIcon,
    leftIcon,
    style,
    avatar,
    headerTextStyle,
    dark,
    name,
    leftIconColor,
    rightIconColor,
    cobranding,
    displayCobranding,
    txOptions,
    rightElement,
    rightDataSet,
  } = props

  const renderHeading = () => {
    if (Platform.OS === 'web') {
      return (
        <h1 style={{ margin: 0, overflow: 'hidden' }}>
          <Text
            numberOfLines={1}
            variant="headline"
            align="center"
            style={{
              color: dark ? color.white : color.black,
              ...headerTextStyle,
            }}
            disableLink
            text={headerText}
            tx={headerTx}
            txOptions={txOptions}
          />
        </h1>
      )
    } else {
      return (
        <Text
          numberOfLines={1}
          variant="labelEmphasized"
          style={{ color: dark ? color.white : color.black, ...headerTextStyle }}
          text={headerText}
          tx={headerTx}
          disableLink
          txOptions={txOptions}
        />
      )
    }
  }

  return (
    <View style={{ ...ROOT, ...style }}>
      {displayCobranding && cobranding ? (
        <View
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            position: 'absolute',
            marginHorizontal: Platform.OS === 'web' ? 0 : spacing[4],
          }}
        >
          <Image
            style={{ height: 30, width: 100 }}
            resizeMode="contain"
            source={{ uri: cobranding }}
          />
        </View>
      ) : null}
      {leftIcon && (
        <TouchableOpacity
          accessibilityLabel="Back"
          accessibilityRole="button"
          style={{ alignItems: 'flex-start' }}
          onPress={onLeftPress}
        >
          <View style={{ right: 4 }}>
            <SvgIcon
              src={leftIcon}
              color={leftIconColor ? leftIconColor : dark ? color.white : color.black}
              size={24}
            />
          </View>
        </TouchableOpacity>
      )}
      {!center ? (
        <View style={TITLE}>
          <Text variant="headline" text={headerText} tx={headerTx} txOptions={txOptions} />
        </View>
      ) : null}
      {center && <View style={[TITLE, { justifyContent: 'center' }]}>{renderHeading()}</View>}
      {rightIcon ? (
        <TouchableOpacity
          // @ts-ignore
          dataSet={rightDataSet}
          onPress={onRightPress}
        >
          <SvgIcon
            src={rightIcon}
            color={rightIconColor ? rightIconColor : dark ? color.white : color.black}
            size={24}
          />
        </TouchableOpacity>
      ) : rightElement ? (
        rightElement
      ) : (
        <View style={SPACER} />
      )}
      {avatar && name && <Avatar size="small" name={name} />}
    </View>
  )
}
